import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatTruncated, MAX_DISPLAY_DECIMALS } from 'src/app/shared/number-format.util';

/**
 * Substituto do DecimalPipe (`number`) que corta as casas decimais em vez de
 * arredondar e limita a 3 casas. Aceita a mesma sintaxe de digitsInfo
 * `{minInt}.{minFrac}-{maxFrac}` (padrão '1.0-3').
 */
@Pipe({
  name: 'truncNumber',
  standalone: true,
})
export class TruncNumberPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private defaultLocale: string) {}

  transform(
    value: number | string | null | undefined,
    digitsInfo = '1.0-3',
    locale?: string,
  ): string | null {
    if (value === null || value === undefined || value === '') return null;
    const num = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(num)) return null;

    const match = /^(\d+)?\.((\d+)(-(\d+))?)?$/.exec(digitsInfo);
    if (!match) {
      throw new Error(`${digitsInfo} is not a valid digit info`);
    }
    const [, minInt, , minFrac, , maxFrac] = match;
    const minDecimals = minFrac != null ? Number(minFrac) : undefined;

    return formatTruncated(num, {
      locale: locale ?? this.defaultLocale,
      minIntegerDigits: minInt != null ? Number(minInt) : 1,
      minDecimals,
      maxDecimals: maxFrac != null ? Number(maxFrac) : MAX_DISPLAY_DECIMALS,
    });
  }
}
